module.exports = __webpack_public_path__ + "fonts/question_70x70.20e797e19a83c6e699d811561b53eb51.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/question_70x70.png
// module id = 755
// module chunks = 9